import { InputImage } from "@sellar-io/components";
import { useState } from "react";
import { useSellarUser } from "../../hooks";
import { useUser } from "../../hooks/api/v2/user/useUser";
import { useUserUpdate } from "../../hooks/api/v2/user/useUserUpdate";
import { useFirebaseImageUpload } from "../../hooks/useFirebaseImageUpload";
import { ProfileImageRemoveModal } from "./ProfileImageRemoveModal";

export function ProfileImageUpload() {
  const { user } = useSellarUser();
  const uploadImage = useFirebaseImageUpload();
  const [removeImageActive, setRemoveImageActive] = useState(false);
  const userQuery = useUser(parseInt(user?.id.toString() ?? ""), {
    enabled: !!user?.id,
  });

  const userUpdateMutation = useUserUpdate(
    user?.id ? parseInt(user.id.toString()) : 0,
  );

  return (
    <>
      {userQuery.data && (
        <>
          <InputImage
            value={userQuery.data.profileImageUrl ?? ""}
            uploadFile={uploadImage}
            onChange={(url) => {
              userUpdateMutation.mutate({
                data: {
                  profileImageUrl: url,
                },
              });
            }}
            onRemove={() => setRemoveImageActive(true)}
          />
          <ProfileImageRemoveModal
            active={removeImageActive}
            onDismiss={() => setRemoveImageActive(false)}
          />
        </>
      )}
    </>
  );
}
